(function($) {

  $('.page-header__highlight .container').attr('data-midnight', 'light');
  $('.page-header__preview .container').attr('data-midnight', 'light');

  $('.missies').attr('data-midnight', 'light');

  var element = $('#Midnight');
  if( element.length ) element.midnight();

  // reageert op attribute :
  // data-midnight="light"
  // data-midnight="dark"

})(jQuery);